module.exports = __webpack_public_path__ + "static/phyppz-bg-f2d3e5c6023775fe707bbfd7e5c931a1.png";